import React from 'react'
import Select from './Select'

export const STATUSES = [
  { id: 'all', name: 'Enrollment: all' },
  { id: 'true', name: 'Enrolled' },
  { id: 'false', name: 'Not enrolled' },
]

export default function EnrollmentStatusSelect(props) {
  return <Select {...props} options={STATUSES} />
}
